<template>
  <ym-loadmore v-if="list.length > 0"
               class="comment-list-component"
               v-model="loading"
               :finished="allLoad"
               @load="loadReview"
  >
    <item v-for="(item, index) in list"
          :key="index"
          :item="item"
          :show-come-from="showComeFrom"
          :show-reply="showReply"
          @reply="handleClickReply"
    />
  </ym-loadmore>
  <div class="empty"
       v-else
  >
    暂无评论
  </div>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import Item from '@/components/CommentList/Item';
  import { getWorkCommentList, getAudioCommentList } from '@/services/comment';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'CommentList',
    components: {
      'ym-loadmore': Loadmore,
      Item,
    },
    props: {
      disableScroll: {
        type: Boolean,
        default: false,
      },
      reviews: {
        type: Array,
        required: true,
      },
      nextStart: {
        type: Number,
        required: true,
      },
      targetId: {
        type: Number,
        required: true,
      },
      targetType: {
        type: String,
        required: true,
      },
      showComeFrom: {
        type: Boolean,
        default: false,
      },
      showReply: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        list: [],
        start: 0,
        allLoad: false,
        loading: false,
      };
    },
    watch: {
      disableScroll(val) {
        this.loading = val;
      },
      reviews(val) {
        this.list = val;
      },
      nextStart(val) {
        this.start = val;
      },
    },
    methods: {
      getAudioCommentList(isLoadMore) {
        return getAudioCommentList({
          targetId: this.targetId,
          limit: LIMIT,
          start: this.start,
          targetType: this.targetType,
        }, isLoadMore);
      },
      getWorkCommentList(isLoadMore) {
        return getWorkCommentList({
          targetId: this.targetId,
          limit: LIMIT,
          start: this.start,
          targetType: this.targetType,
        }, isLoadMore);
      },
      getCommentList(type, isLoadMore) {
        if (type === 'work') return this.getWorkCommentList(isLoadMore);
        return this.getAudioCommentList(isLoadMore);
      },
      async loadReview(isLoadMore = true) {
        if (this.allLoad) return;
        this.loading = true;

        const data = await this.getCommentList(this.targetType, isLoadMore);
        if (data.list.length === 0) {
          this.allLoad = isLoadMore;
          this.loading = false;
          return;
        }
        this.list = [...this.list, ...data.list];
        this.start = data.start;
        this.loading = false;
      },
      handleClickReply(data) {
        this.$emit('reply', data);
      },
    },
    created() {
      this.list = this.reviews;
      this.start = this.nextStart;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .comment-list-component {
    padding: 0 @size-medium;
    word-break: break-all;
  }
</style>
